import {CheckIcon, XCircleIcon} from 'lucide-react';
import {ReactNode} from 'react';

export type ToastMessageProps = {
  message: string;
  type: 'success' | 'error' | 'info' | 'progress' | 'warning';
  details?: ReactNode;
};

export const ToastMessage = ({message, type = 'success', details}: ToastMessageProps) => {
  if (type === 'error')
    return (
      <div>
        <div className="flex flex-row gap-2">
          <XCircleIcon color="red" className="w-6 h-6" />
          <p className="text-red-600">{message}</p>
        </div>
        {details}
      </div>
    );
  if (type === 'success')
    return (
      <div>
        <div className="flex flex-row gap-2">
          <CheckIcon color="blue" className="w-6 h-6" />
          <p className="text-blue-600">{message}</p>
        </div>
        {details}
      </div>
    );

  return (
    <div className="flex flex-row gap-2">
      <p>{message}</p>
    </div>
  );
};

export default ToastMessage;
